module.exports = __webpack_public_path__ + "static/media/galeria-fotos-6.c3852392.png";